// crewFormat.js — time + number formatters and the simulated "now" clock.
const MS = 60000;

const today0 = (() => { const d = new Date(); d.setHours(0, 0, 0, 0); return d; })();
export const at = (h, m) => today0.getTime() + (h * 60 + m) * MS;

export const simNow = () => Date.now();   // real wall-clock; Phase-2 uses live server timestamps

export const hhmm = (ms) => {
  const d = new Date(ms); let h = d.getHours(); const m = d.getMinutes();
  const ap = h >= 12 ? 'PM' : 'AM'; h = h % 12 || 12;
  return `${h}:${String(m).padStart(2, '0')} ${ap}`;
};

export const fmtMi = (pct) => (pct * 0.42).toFixed(1);
export const fmtFt = (ft) => (ft < 1000 ? `${Math.round(ft)} ft` : `${(ft / 5280).toFixed(1)} mi`);

export function fmtMin(m) {
  m = Math.round(m || 0); const h = Math.floor(m / 60), mm = m % 60;
  return h > 0 ? (mm ? `${h}h ${mm}m` : `${h}h`) : `${mm}m`;
}

export function fmtDur(ms, withSec = false) {
  if (ms < 0) ms = 0;
  const s = Math.floor(ms / 1000), h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
  if (withSec) return `${h}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
  return h > 0 ? `${h}h ${String(m).padStart(2, '0')}m` : `${m}m`;
}

export { MS };
